export const enum CREDIT_PRODUCT_RESPONSE_TYPES {
    DEFAULT = 1, // => 'Обычный список',
    COUNT = 2, // => 'Общее кол-во предложений'
}
